export default __webpack_public_path__ + "static/media/Edit.477eafdf.svg";